// Shared scope bucketing so the frame list, scope totals, split preview and
// split download all group scopes identically (case/space-insensitive, blank →
// Unassigned) and never drift apart.
export const UNASSIGNED_KEY = "__unassigned__";
export const UNASSIGNED_TITLE = "Unassigned";

export function normalizeScope(scope) {
  return String(scope ?? "")
    .trim()
    .replace(/\s+/g, " ");
}

/** A scope's stable grouping `key` and display `title`. */
export function scopeBucket(scope) {
  const normalized = normalizeScope(scope);
  return normalized
    ? { key: normalized.toLowerCase(), title: normalized }
    : { key: UNASSIGNED_KEY, title: UNASSIGNED_TITLE };
}
